import { BadgeDomain } from "../../Abstractions/BadgeDomain";
import { Card } from "react-bootstrap";
import { ORDER_STATUS } from "../../../domain/Orders/OrderStatus";

export function OrderDriverActionsDetailsView({ orderStatus, driverActionsDetails }) {
  const { isConfirmedByDriver, isCourseCompletedByDriver, isKpoConfirmationGeneratedByDriver } = driverActionsDetails || {};
  if(!isConfirmedByDriver && !isCourseCompletedByDriver && !isKpoConfirmationGeneratedByDriver) {
    return;
  }

  if(isCourseCompletedByDriver && orderStatus !== ORDER_STATUS.CONFIRMED) {
    return;
  }

  return <Card.Title>
    Kierowca:{" "}
    {isKpoConfirmationGeneratedByDriver && <BadgeDomain bg="navy">Wygenerowane KPO</BadgeDomain>}
    {isConfirmedByDriver && !isCourseCompletedByDriver && <BadgeDomain bg="lightblue">Kurs rozpoczęty</BadgeDomain>}
    {isCourseCompletedByDriver && <BadgeDomain bg="dodgerblue">Kurs zakończony</BadgeDomain>}
  </Card.Title>;
}